export default "__VITE_ASSET__CVufCrM7__"